<section class="about-us " id="about-us">
    <div class="container about_us">
        <div class="row">
            <div class="col-md-2 "></div>
            <div class="col-md-10 ">
                <div class="header-block">
                    <h2>Anima Benefits</h2>
                    <p>
                        Anima is your AI companion for mental clarity — grounded in science, guided by empathy.
                        It’s built on four core pillars: cutting-edge neuroscience, eye-tracking technology, total privacy, and objective insight into how your mind works.

                    </p>
                </div>
            </div>
        </div>

        <app-about-us-ai-item [item]="item" *ngFor="let item of data"></app-about-us-ai-item>

        <!--        <app-achivement></app-achivement>-->

    </div>
</section>
